const getAddressRows = (size, config)=>config[size]
;
const parseAddress = (addressRows, addressData)=>{
    const replacements1 = Object.entries(addressData).map(([key, value])=>({
            regExp: new RegExp(`\{${key}\}`, 'g'),
            value
        })
    );
    const inject = (row, replacements)=>replacements.reduce((acc, { regExp , value  })=>value === undefined ? acc : acc.replace(regExp, String(value))
        , row)
    ;
    const clean = (row)=>{
        const unusedTemplateRegExp = new RegExp(/{([^}]+)}/, 'g');
        return row.trim().replace(unusedTemplateRegExp, '').split(',').map((el)=>el.trim()
        ).filter((el)=>!!el
        ).join(', ');
    };
    return addressRows.map((row)=>inject(row, replacements1)
    ).map(clean);
};

export { getAddressRows, parseAddress };
//# sourceMappingURL=utils.js.map
